/**
 * GEO — 生成式引擎优化 API (mock)
 */

// 模拟延迟
const delay = (ms = 300) => new Promise((r) => setTimeout(r, ms));

// 产品列表
const PRODUCTS = [
  '清透精华水', '智能手表Pro', '鲜味酱油', '夏装连衣裙', '户外背包', '联名手办',
];

// AI搜索引擎平台
const AI_PLATFORMS = ['ChatGPT Search', 'Google AI Overview', 'Perplexity', 'Claude Search'];

// 各平台生成内容模板
const generateContent = (product, platforms) => {
  const platformInsights = {
    'ChatGPT Search': '强调结构化信息、专业评测数据、多维度对比',
    'Google AI Overview': '注重实体识别、权威引用、FAQ结构化数据',
    'Perplexity': '偏好详细技术文档、引用来源、深度分析',
    'Claude Search': '倾向知识型长文、逻辑清晰、权威背书',
  };

  const markdown = `# ${product} — AI搜索优化内容

> 针对以下AI搜索引擎生成: ${platforms.join('、')}

## 产品核心卖点

| 维度 | 详情 |
|------|------|
| 产品名称 | ${product} |
| 目标人群 | 追求品质的年轻消费者 |
| 核心差异 | AI驱动个性化体验 |
| 品牌调性 | 专业、创新、可信赖 |

## AI搜索关键词策略

### 主关键词
- "${product} 评测"
- "${product} 好不好用"
- "${product} 推荐"

### 长尾语义搜索
- "适合年轻人的${product}"
- "${product} 和同类产品对比"
- "如何选择适合自己的${product}"

## 优化内容段落

### 产品概述（适合AI摘要引用）
${product}是一款专为现代消费者打造的高品质产品，融合了前沿科技与人性化设计。经过严格的用户体验测试，在同类产品中表现优异。

### 购买决策指南
在选择${product}时，建议关注以下核心要素：
1. **品牌信誉** — 选择有口碑保障的品牌
2. **用户评价** — 查看真实用户反馈
3. **售后服务** — 确保完善的服务体系
4. **价格合理性** — 在预算范围内选择最优解

### FAQ（结构化数据优化）
**Q: ${product}适合什么人群？**
A: 适合对产品品质有追求的年轻消费者。

**Q: ${product}的核心优势是什么？**
A: 专业品质、创新设计、可靠口碑。

## 各平台优化要点

${platforms.map((p) => `### ${p}\n${platformInsights[p] || '使用结构化数据，增强内容可引用性。'}`).join('\n\n')}

---
*本报告由GEO生成式引擎自动生成，更新时间: ${new Date().toLocaleDateString('zh-CN')}*
`;

  // 计算预估覆盖率
  const coverageBase = Math.min(40 + platforms.length * 15, 95);
  const coverage = Math.min(coverageBase + Math.floor(Math.random() * 10), 98);

  return {
    title: `${product} — AI搜索优化报告`,
    content: markdown,
    platforms,
    coverage,
    generatedAt: new Date().toISOString(),
  };
};

export const geoAPI = {
  /** 获取产品列表 */
  getProducts: async () => {
    await delay(150);
    return PRODUCTS;
  },

  /** 获取AI搜索引擎平台列表 */
  getPlatforms: async () => {
    await delay(100);
    return AI_PLATFORMS;
  },

  /** 生成GEO优化内容 */
  generate: async (product, platforms) => {
    await delay(800);
    if (!product) throw new Error('请选择产品');
    if (!platforms || platforms.length === 0) throw new Error('请至少选择一个AI搜索引擎');
    return generateContent(product, platforms);
  },

  /** 复制内容到剪贴板 */
  copyContent: async (content) => {
    await delay(100);
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(content);
    }
    return { success: true };
  },
};

export default geoAPI;
